import Button from "@mui/material/Button";
import React from "react";
import { getI18NMessage } from "../../../i18n/I18N";
import AppUtil, { getAppURL } from "../../../utils/AppUtil";
import './Permissions.scss';
import nimbleLogo from './../../../../assets/images/logos/logo.png';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import properties from "../../../properties";

class Permission extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.acceptBtnClick = this.acceptBtnClick.bind(this);
        this.cancelBtnClick = this.cancelBtnClick.bind(this);
        this.callCodeEndpoint = this.callCodeEndpoint.bind(this);
    }

    validateRequestAndSetState = ()=> {
        const urlParams = new URLSearchParams(window.location.search);        
        const clientId = urlParams.get('client_id');

        if(!clientId){
            this.setState({
                oauthRequestValidationError: {
                    laymanError: "The app requesting permission does not provide enough detail to identity it.",
                    devError: "'client_id' not provided"
                }
            });
            return;
        }

        this.setState({
            oAuthUrlParams: urlParams
        });
        return clientId;
    }

    componentDidMount() {
        const clientId = this.validateRequestAndSetState();
        let URL = getAppURL('GET_OAUTH_CLIENT');
        if(properties.isIntegrated){
            URL+="/"+clientId;
        }
        AppUtil.ajax(URL, undefined, response => {
            this.setState({
                "oauthData": response
            });
            if(!this.state.oauthData.clientName){
                this.setState({
                    oauthRequestValidationError: {
                        laymanError: "The app requesting for permission is not registered with Nimble.",
                        devError: `'client_id': ${clientId} does not exist`
                    }
                })
            }
        })

    }

    callCodeEndpoint = acceptOrDeny => {
        const URL = getAppURL('GET_OAUTH_CODE');
        const oAuthUrlParams = this.state.oAuthUrlParams;
        oAuthUrlParams.set("authorized", acceptOrDeny);
        oAuthUrlParams.set("nocache", (new Date()).getTime());
        window.location.href = URL + "?"+oAuthUrlParams.toString();
    }

    acceptBtnClick(){
        this.callCodeEndpoint(true);
    }

    cancelBtnClick(){
        this.callCodeEndpoint(false);
    }

    renderError(){
        return (
            <div className="permission-page">
            <div className='permissions-box'>
                <div className="permissions-header">
                    <div className="permission-header-flow-diagram">
                        <img src={ `${window.appCdnPath || ''}${nimbleLogo}` } className='nimble-logo' alt={ getI18NMessage('logalt') } />
                    </div>
                    <div className="permission-header-text">
                        <b>Error</b> by the requesting app.
                    </div>
                </div>
                <div className="permissions-body">
                    <div className="permission-error">
                        <div className="layman-error">
                            {this.state.oauthRequestValidationError.laymanError}
                        </div>
                        <div className="dev-error">
                            {this.state.oauthRequestValidationError.devError}
                        </div>
                </div>
                </div>
            </div>
            </div>
        )
    }

    render() {
        if(this.state.oauthRequestValidationError){
            return this.renderError();
        }
        if(!this.state.oauthData){
            return false;
        }

        const {clientName, scopeDescriptions} = this.state.oauthData;
        return (
            <div className="permission-page">
                <div className='permissions-box'>
                    <div className="permissions-header">
                        <div className="permission-header-flow-diagram">
                            <img src={ nimbleLogo } className='nimble-logo' alt={ getI18NMessage('logalt') } />
                        </div>
                        <hr/>
                        <div className="permission-header-text">
                            <b>{clientName}</b> would like to: 
                        </div>

                    </div>

                    <div className="permissions-body">
                        {scopeDescriptions.map(item => 
                            <div className="permission-item" key={item.id}>
                                <DoneAllIcon/>
                                {item}
                            </div>
                            )} 
                    </div>

                    <div className="permissions-footer">
                        <div className="permission-acceptance-info">
                            Accepting these permissions means that you allow <b>{clientName}</b> 
                            app to use your data as specified in their Terms of Service and Privacy Policy statement.
                        </div>
                        <div className="permission-buttons">
                            <Button variant="contained"
                                color="grey"
                                    onClick={ this.cancelBtnClick }>
                                        { getI18NMessage('oauth_cancel_btn') }
                                        </Button>
                            <Button variant="contained"
                            
                            onClick={ this.acceptBtnClick }>
                            { getI18NMessage('oauth_authorize_btn') }
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default Permission;
